import { useLocationTestId } from '@/hooks/useTestId'
import localeText from '@/locales/datagrid'
import { Button } from '@/global/components/Button'
import { PlusIcon } from 'lucide-react'
import React from 'react'
import { match } from 'ts-pattern'
import { IDataTableProps } from '../DataTable'

interface IProps {
    onAdd?: IDataTableProps['onAdd']
    children?: React.ReactNode
}

export default function GridToolbarRightSide({ children, onAdd }: IProps) {
    const adicionarTestId = useLocationTestId('adicionar')

    return (
        <div className="inline-flex items-center gap-2">
            {children}
            {match(onAdd)
                .when(
                    () => React.isValidElement(onAdd),
                    () => onAdd as React.ReactNode,
                )
                .when(
                    () => typeof onAdd === 'function',
                    () => (
                        <Button
                            onClick={onAdd as () => void}
                            variant="contained"
                            size="small"
                            data-testid={adicionarTestId}
                            className="flex text-nowrap gap-2 h-10 ml-auto items-center"
                        >
                            <PlusIcon className="size-6" />
                            <span className="hidden sm:block">
                                {localeText.filterPanelAddFilter}
                            </span>
                        </Button>
                    ),
                )
                .otherwise(() => null)}
        </div>
    )
}
